<template>
  <v-container grid-list-lg fluid>
    <v-toolbar dense flat color="grey lighten-3">
      <v-toolbar-title>Campaign Edit</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="pink darken-1" dark @click="submit">Update</v-btn>
      <v-btn color="primary" text @click="close">Cancel</v-btn>
    </v-toolbar>
    <v-layout column class="touch-view-container">
      <v-flex shrink>
        <v-card outlined>
          <v-toolbar dense flat color="grey lighten-3">
            <v-toolbar-title>Title & Image</v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="font-weight-bold">Donation Type </span>
            <v-btn-toggle active-class="custom-active-class" mandatory dense v-model="Campaign.type" color="primary"
              group>
              <v-btn value="donation" outlined class="ma-1">
                Donation
              </v-btn>
              <v-btn value="sponsor" outlined class="ma-1">
                Sponsor
              </v-btn>

            </v-btn-toggle>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field outlined autofocus :hide-details="nameErrors.length === 0" dense
                  :error-messages="nameErrors" v-model="Campaign.name" label="Title"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <quill-editor :content="Campaign.description" :options="editorOption" @change="onEditorChange($event)" />
              </v-flex>
            </v-layout>
            <v-flex>
              <v-layout row wrap align-center>
                <v-flex>
                  Banner Image
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 md3>
                  <v-card height="150" color="grey lighten-4" @click="pickFile" hover outlined>
                    <v-layout v-if="!Campaign.url" align-center="align-center" justify-center="justify-center"
                      column="column" fill-height="fill-height">
                      <v-flex shrink>
                        <img height="50"
                          src="data:image/svg+xml;utf8;base64,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" />
                      </v-flex>
                      <v-flex shrink>
                        <div class="text-center">Dimension: 1024 x 400 (px)</div>
                      </v-flex>
                    </v-layout>



                    <img height="150" :src="Campaign.url" v-if="Campaign.url" />
                  </v-card>
                  <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />
                </v-flex>

              </v-layout>
            </v-flex>
            <v-divider></v-divider>
            <v-flex>
              <div>Select Category
              </div>
              <v-btn-toggle active-class="custom-active-class" dense mandatory v-model="selectedProduct" color="primary"
                group>
                <v-row class="ml-2 mt-1">
                  <v-btn v-for="product in Products" :key="product.id" outlined :value="product" class="ma-1">
                    {{ product.name }}
                  </v-btn>
                </v-row>
              </v-btn-toggle>
            </v-flex>
            <v-divider class="mt-5"></v-divider>
            <v-flex>
              <v-layout row align-center justify-space-between>
                <v-flex xs12 md8>
                  <span class="font-weight-bold">Publish</span>
                  <p>Turn on this feature to publish the page. Once activated,
                    the page will be visible to the public, allowing them to access its contents.</p>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                  <div class="text-right">
                    <v-switch inset v-model="Campaign.isActive"></v-switch>
                  </div>

                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex shrink v-if="Campaign.type === 'donation'">
        <v-card outlined>
          <v-toolbar dense flat color="grey lighten-3">
            <v-toolbar-title>Goal & Value</v-toolbar-title>
            <v-spacer></v-spacer>

          </v-toolbar>
          <v-card-text>
            <v-layout column>
              <v-flex>
                <v-layout row wrap align-center>
                  <v-flex xs12 md8>
                    <span class="font-weight-bold">Goal Amount</span>
                    <p>You can set a goal amount, but reaching it doesn't stop the donation collection. Instead,
                      it shows progress towards the goal, indicating how much has been achieved compared to the selected
                      target.</p>
                  </v-flex>

                  <v-spacer></v-spacer>
                  <v-flex xs12 md2>
                    <v-text-field outlined dense hide-details v-model="Campaign.dontationGoal"
                      label="Donation Goal"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row align-center justify-space-between>
                  <v-flex xs12 md8>
                    <span class="font-weight-bold">Show Donate Count</span>
                    <p>Activate this feature to display the number of donations made by visitors, rather than only showing
                      the count of page visits.
                      This allows others to see the engagement level and participation of donors on the page.</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <div class="text-right">
                      <v-switch inset v-model="Campaign.metadata.showDonateCount"></v-switch>
                    </div>

                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row align-center justify-space-between>
                  <v-flex xs12 md8>
                    <span class="font-weight-bold">Show Visitors Count</span>
                    <p>Enable this feature to display the number of visitors who have accessed the page.
                      This provides transparency regarding the level of interest and traffic the page is receiving.</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <div class="text-right">
                      <v-switch inset v-model="Campaign.metadata.showVisitorsCount"></v-switch>
                    </div>

                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row align-center justify-space-between>
                  <v-flex xs12 md8>
                    <span class="font-weight-bold">Show Goal/Funds</span>
                    <p>Activate this feature to showcase the fundraising progress through a progress bar, indicating the
                      total amount raised by donations compared to the set goal.
                      Visitors will be able to see the goal amount and how much money has been raised so far, fostering
                      transparency and encouraging further donations.</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <div class="text-right">
                      <v-switch inset v-model="Campaign.metadata.showGoalFunds"></v-switch>
                    </div>

                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row align-center justify-space-between>
                  <v-flex xs12 md8>
                    <span class="font-weight-bold">Item Donation Limit</span>
                    <p>When you activate this feature, it locks the item's value.
                      This means that once a total of $1200, or any specified amount, has been collected for that item, no
                      further donations can be made towards it.</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <div class="text-right">
                      <v-switch inset v-model="Campaign.metadata.donationLimit"></v-switch>
                    </div>

                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row wrap align-center>
                  <v-flex xs12 md8>
                    <span class="font-weight-bold">Pre Defined Donation Amount</span>
                    <p>You can enhance this feature by including predefined donation values.
                      Users can select from preset amounts like $10, $50, or $100.
                      Alternatively, they can choose not to use predefined values and easily input a custom donation
                      amount.</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs12 md2>
                    <v-btn color="success" block @click="addValue">
                      <v-icon left>add</v-icon>
                      Add
                    </v-btn>

                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-flex shrink v-for="(item, index) in preDefinedValue" :key="index">
                    <v-chip label close @click:close="removeValue(index)">{{ item | currency }}</v-chip>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>

          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card outlined v-if="Campaign.type === 'sponsor'">
          <v-toolbar dense flat color="grey lighten-3">
            <v-toolbar-title>Sponsor</v-toolbar-title>
            <v-spacer></v-spacer>

          </v-toolbar>
          <v-card-text>
            <v-layout column>

              <v-flex>
                <v-layout row align-center justify-space-between>
                  <v-flex xs12 md8>
                    <span class="font-weight-bold">Item Donation Limit</span>
                    <p>When you activate this feature, it locks the item's value.
                      This means that once a total of $1200, or any specified amount, has been collected for that item, no
                      further donations can be made towards it.</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <div class="text-right">
                      <v-switch inset v-model="Campaign.metadata.donationLimit"></v-switch>
                    </div>

                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex v-if="!Campaign.metadata.donationLimit">
                <v-layout row wrap align-center>
                  <v-flex xs12 md8>
                    <span class="font-weight-bold">Dynamic Pricing Frequency</span>
                    <p> When you enter a value, choose whether it's monthly or yearly. If you select monthly,
                      the unit price will be collected every month.
                      If you choose yearly, the unit price will be split into 12 months to get the monthly price.
                    </p>

                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs12 md2>
                    <v-select dense outlined :items="durationTypes" v-model="Campaign.metadata.durationType"
                      label="Duration Type" hide-details></v-select>
                  </v-flex>
                </v-layout>

              </v-flex>

              <v-flex>
                <CampaignDetails @submit="addDetail" />
              </v-flex>
              <v-flex>
                <v-data-table id="detail-cart" :headers="headers" hide-default-footer :itemsPerPage="1000"
                  no-data-text="No item on this campaign yet" :items="Campaign.CampaignDetails">
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td>
                        <v-layout align-center justify-start row fill-height wrap>
                          <v-btn icon @click="deleteItem(index)" v-if="!item.delete">
                            <v-icon color="red">delete</v-icon>
                          </v-btn>
                          <v-text-field outlined hide-details v-model="item.category" @focus="$event.target.select()"
                            dense></v-text-field>

                        </v-layout>
                      </td>
                      <td class="text-right">
                        <v-text-field v-model="item.name" outlined type="text" hide-details
                          @focus="$event.target.select()" dense></v-text-field>

                      </td>

                      <td class="text-right">
                        <v-text-field v-model="item.amount" outlined class="al-r" type="number" hide-details
                          @focus="$event.target.select()" dense></v-text-field>

                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import campaignService from "../service.js";
import CampaignDetails from '@/modules/Campaign/components/Details.vue';
const { validationMixin } = require("vuelidate");
import productService from "@/modules/Product/service";
const { required } = require("vuelidate/lib/validators");
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  name: "edit-campaign",
  data() {
    return {
      selectedProduct: null,
      loading: false,
      preDefinedValue: [],
      Campaign: {
        name: null,
        description: null,
        type: null,
        ProductId: null,
        url: null,
        isActive: false,
        dontationGoal: null,
        intervalMonth: this.$moment().format('M'),
        intervalDays: this.$moment().format('D'),
        metadata: {
          preDefinedValue: [],
          donationLimit: false,
          durationType: 'yearly',
          showGoalFunds: true,
          showVisitorsCount: true,
          showDonateCount: false,
        },
        CampaignDetails: []
      },
      ramadanTemplate:[
        {category: 'First Ashra', name: 'Day 1', amount: 500},
        {category: 'First Ashra', name: 'Day 2', amount: 500},
        {category: 'First Ashra', name: 'Day 3', amount: 500},
        {category: 'First Ashra', name: 'Day 4', amount: 500},
        {category: 'First Ashra', name: 'Day 5', amount: 500},
        {category: 'First Ashra', name: 'Day 6', amount: 500},
        {category: 'First Ashra', name: 'Day 7', amount: 500},
        {category: 'First Ashra', name: 'Day 8', amount: 500},
        {category: 'First Ashra', name: 'Day 9', amount: 500},
        {category: 'First Ashra', name: 'Day 10', amount: 500},
        {category: 'Second Ashra', name: 'Day 11', amount: 800},
        {category: 'Second Ashra', name: 'Day 12', amount: 900},
        {category: 'Second Ashra', name: 'Day 13', amount: 500},
        {category: 'Second Ashra', name: 'Day 14', amount: 500},
        {category: 'Second Ashra', name: 'Day 15', amount: 500},
        {category: 'Second Ashra', name: 'Day 16', amount: 500},
        {category: 'Second Ashra', name: 'Day 17', amount: 500},
        {category: 'Second Ashra', name: 'Day 18', amount: 500},
        {category: 'Second Ashra', name: 'Day 19', amount: 500},
        {category: 'Second Ashra', name: 'Day 20', amount: 500},
        {category: 'Thred Ashra', name: 'Day 21', amount: 1200},
        {category: 'Thred Ashra', name: 'Day 22', amount: 1000},
        {category: 'Thred Ashra', name: 'Day 23', amount: 1800},
        {category: 'Thred Ashra', name: 'Day 24', amount: 1000},
        {category: 'Thred Ashra', name: 'Day 25', amount: 1000},
        {category: 'Thred Ashra', name: 'Day 26', amount: 1000},
        {category: 'Thred Ashra', name: 'Day 27', amount: 1800},
        {category: 'Thred Ashra', name: 'Day 28', amount: 1000},
        {category: 'Thred Ashra', name: 'Day 29', amount: 800},
        {category: 'Thred Ashra', name: 'Day 30', amount: 800},
      ],
      editorOption: {
        placeholder: 'Description',
      },
      headers: [
        {
          text: "Category",
          align: "left",
          value: "category",
          sortable: false,
        },
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Amount",
          align: "right",
          value: "amount",
          sortable: false,
        },
      ],
      Products: [],
      campaignTypes: ['donation', 'sponsor'],
      durationTypes: ['monthly', 'yearly']
    };
  },
  mixins: [validationMixin],
  validations: {
    Campaign: {
      name: {
        required,
      },
      type: {
        required,
      },
      ProductId: {
        required
      }
    },
  },
  created() {
    this.loadData()
    this.getProduct()
  },
  components: {
    CampaignDetails,
    quillEditor
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Campaign.name.$dirty) return errors;
      if (!this.$v.Campaign.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    typeErrors() {
      const errors = [];
      if (!this.$v.Campaign.type.$dirty) return errors;
      if (!this.$v.Campaign.type.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    ProductIdErrors() {
      const errors = [];
      if (!this.$v.Campaign.ProductId.$dirty) return errors;
      if (!this.$v.Campaign.ProductId.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
  },
  methods: {
    removeValue(index) {
      this.preDefinedValue.splice(index, 1);
    },
    addValue() {
      this.$swal.fire({
        title: "Enter Value",
        input: "number",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: "Save",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        console.log('result', result)
        if (result.value) {
          this.preDefinedValue.push(result.value)

        } else {
          this.$swal.fire({
            title: 'Please enter valid value.',
          });
        }
      });
    },
    close() {
      this.empty();
      this.$router.go(-1)
    },
    onEditorChange({ html }) {
      this.Campaign.description = html
    },
    getProduct() {
      this.loading = true;
      productService.resetCache()
      return productService.getAll({ publicDonation: true }).then((result) => {
        this.Products = result.data;
        this.loading = false;
        productService.resetCache()
      });
    },
    loadData(){
      const { id } = this.$route.params;
      return campaignService.getById(id).then((response) => {
        console.log("Loading data response ", response)
        this.Campaign = response.data;
        this.selectedProduct.id = this.Campaign.ProductId
        this.preDefinedValue = this.Campaign.metadata.preDefinedValue
        return response;
      }).catch((error) => {
        console.log("error", error);
      });
    },
    onFilePicked(e) {
      const { files } = e.target;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.Campaign.imageUrl = fr.result;
        });
      } else {
        this.imageName = '';
        this.Campaign.image = '';
        this.Campaign.imageUrl = '';
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    addDetail(val){
      val.create = true
      this.Campaign.CampaignDetails.push(val)
    },
    deleteItem(i) {
      let editedItem = this.Campaign.CampaignDetails[i]
      editedItem.delete = true
      this.Campaign.CampaignDetails.splice(i, 1, editedItem)
    },
    empty() {
      this.loading = false,
        this.Campaign = {
          name: null,
          description: null,
          type: null,
          ProductId: null,
          isActive: false,
          dontationGoal: null,
          url: null,
          metadata: {
            donationLimit: false,
            durationType: 'yearly',
            showGoalFunds: true,
            showVisitorsCount: true,
            showDonateCount: false,
          }
        },
        this.Products = [],
        this.$v.$reset();
    },
    submit() {
      this.Campaign.ProductId = this.selectedProduct.id
      this.Campaign.metadata.preDefinedValue = this.preDefinedValue
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return campaignService
          .update(this.Campaign.id, this.Campaign)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Campaign is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
